const TelegramIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.638 2.068a1 1 0 0 1 1.294 1.294l-7 18a1 1 0 0 1-1.8.134l-3.865-6.764-6.763-3.864a1 1 0 0 1 .134-1.8zm-9.39 12.099 2.58 4.517 4.517-11.616zm-5.933-3.996 4.518 2.582 7.098-7.099z"
    />
  </svg>
);

const SmsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 11c0-2.288-.674-3.693-1.85-4.575C16.91 5.495 14.927 5 12 5s-4.91.495-6.15 1.425C4.674 7.307 4 8.712 4 11c0 1.42.263 2.491.722 3.299.452.795 1.134 1.405 2.102 1.848a1 1 0 0 1 .527 1.245l-.654 1.827 5.212-2.145.089-.032a1 1 0 0 1 .28-.044c2.826-.031 4.737-.541 5.931-1.468C19.346 14.648 20 13.253 20 11M8.01 10a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm4 0a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zm4 0a1 1 0 1 1 0 2H16a1 1 0 1 1 0-2zM22 11c0 2.666-.798 4.738-2.564 6.11-1.672 1.297-4.047 1.83-6.939 1.883l-7.116 2.932a1 1 0 0 1-1.322-1.26l1.118-3.135a6.2 6.2 0 0 1-2.195-2.243C2.305 14.096 2 12.657 2 11c0-2.711.826-4.807 2.65-6.175C6.41 3.505 8.927 3 12 3s5.59.505 7.35 1.825C21.174 6.193 22 8.29 22 11"
    />
  </svg>
);

const WhatsappIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 12a8 8 0 1 0-14.78 4.249 1 1 0 0 1 .104.842l-.803 2.467 2.72-.728.097-.02a1 1 0 0 1 .663.12A8 8 0 0 0 20 12M8.145 7.589c.198-.1.457-.17.749-.123.285.046.498.186.637.316.243.227.372.521.434.673.074.18.14.388.192.541.15.446.232.977-.028 1.484a1.8 1.8 0 0 1-.546.61 8.9 8.9 0 0 0 1.615 1.877A9 9 0 0 0 13.3 14.33c.102-.185.269-.436.53-.617.467-.326 1.004-.317 1.466-.229.16.03.375.07.562.12.16.04.468.128.725.338.148.121.316.313.4.59.085.283.051.548-.022.758-.126.361-.398.635-.61.821-.517.455-1.152.597-1.734.59-.575-.008-1.165-.16-1.71-.368-1.09-.418-2.201-1.141-3.025-1.861s-1.685-1.719-2.24-2.74c-.277-.51-.503-1.072-.584-1.64-.083-.575-.024-1.22.355-1.79l.132-.186c.148-.193.344-.398.6-.528M22 12c0 5.523-4.477 10-10 10a9.96 9.96 0 0 1-4.629-1.135l-4.112 1.1a1 1 0 0 1-1.21-1.275l1.233-3.79A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10"
    />
  </svg>
);

const EmailIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m20 9.868-6.336 4.225a3 3 0 0 1-3.328 0L4 9.868V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zM20 7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v.465l7.445 4.964a1 1 0 0 0 1.11 0L20 7.465zm2 10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3z"
    />
  </svg>
);

const CallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.306 2.32a3 3 0 0 1 3.271 1.599l.618 1.235a2.874 2.874 0 0 1-.845 3.584.6.6 0 0 0-.202.236.1.1 0 0 0-.01.038l.003.006c.319.76 1.093 1.801 2.066 2.775.973.973 2.014 1.747 2.775 2.066l.006.002c.002 0 .015 0 .038-.01a.6.6 0 0 0 .236-.2 2.874 2.874 0 0 1 3.584-.846l1.235.618a3 3 0 0 1 1.6 3.271l-.38 1.894c-.274 1.373-1.517 2.487-3.05 2.313-7.726-.874-14.278-7.426-15.152-15.152-.174-1.533.94-2.776 2.313-3.05zm.392 1.96-1.894.38c-.497.099-.759.503-.718.864.77 6.8 6.59 12.62 13.39 13.39.361.041.765-.22.865-.718l.379-1.894a1 1 0 0 0-.534-1.091l-1.235-.617a.87.87 0 0 0-1.089.257c-.5.667-1.517 1.329-2.652.853-1.108-.464-2.365-1.445-3.417-2.497S8.76 10.897 8.296 9.79c-.476-1.135.186-2.152.853-2.652a.87.87 0 0 0 .257-1.09L8.79 4.814A1 1 0 0 0 7.7 4.28M20 11a7 7 0 0 0-7-7 1 1 0 0 1 0-2 9 9 0 0 1 9 9 1 1 0 1 1-2 0m-6.969-4.123a1 1 0 0 1 1.218-.72 5.01 5.01 0 0 1 3.594 3.594 1 1 0 0 1-1.938.498 3 3 0 0 0-2.154-2.154 1 1 0 0 1-.72-1.218"
    />
  </svg>
);

export const VERIFICATION_CHANNEL = {
  TELEGRAM: 'telegram',
  SMS: 'sms',
  WHATSAPP: 'whatsapp',
  CALL: 'call',
  EMAIL: 'email',
};

export const VERIFICATION_CHANNEL_MAP = {
  [VERIFICATION_CHANNEL.EMAIL]: {
    channel: VERIFICATION_CHANNEL.EMAIL,
    label: 'Email',
    description: 'Send code by email',
    target: 'email',
    Icon: EmailIcon,
  },
  [VERIFICATION_CHANNEL.TELEGRAM]: {
    channel: VERIFICATION_CHANNEL.TELEGRAM,
    preferredChannel: 'telegram_contact',
    label: 'Telegram',
    description: 'Send code in Telegram',
    target: 'phone',
    Icon: TelegramIcon,
  },
  [VERIFICATION_CHANNEL.SMS]: {
    channel: VERIFICATION_CHANNEL.SMS,
    label: 'SMS',
    description: 'Send code by text message',
    target: 'phone',
    Icon: SmsIcon,
  },
  [VERIFICATION_CHANNEL.WHATSAPP]: {
    channel: VERIFICATION_CHANNEL.WHATSAPP,
    label: 'WhatsApp',
    description: 'Send code in WhatsApp',
    target: 'phone',
    Icon: WhatsappIcon,
  },
  [VERIFICATION_CHANNEL.CALL]: {
    channel: VERIFICATION_CHANNEL.CALL,
    label: 'Call',
    description: 'Get code by phone call',
    target: 'phone',
    Icon: CallIcon,
  },
};

export const ENABLED_VERIFICATION_CHANNELS = [
  VERIFICATION_CHANNEL.TELEGRAM,
  VERIFICATION_CHANNEL.EMAIL,
];

export const TELEGRAM_CONTACT_CHANNEL = VERIFICATION_CHANNEL_MAP[
  VERIFICATION_CHANNEL.TELEGRAM
].preferredChannel;

export function getAvailableVerificationChannels({
  email = false,
  phone = false,
} = {}) {
  const availableTargets = {
    email: Boolean(email),
    phone: Boolean(phone),
  };

  return ENABLED_VERIFICATION_CHANNELS.filter((channel) => (
    availableTargets[VERIFICATION_CHANNEL_MAP[channel].target]
  ));
}
